import { render } from "./DocumentItem.vue?vue&type=template&id=d328686a&scoped=true"
import script from "./DocumentItem.vue?vue&type=script&lang=js"
export * from "./DocumentItem.vue?vue&type=script&lang=js"

import "./DocumentItem.vue?vue&type=style&index=0&id=d328686a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d328686a"]])

export default __exports__